import React from 'react';

import { useProperty } from '../../../features/property/context';

import Button from '../../atoms/Button';
import Text from '../../atoms/Text';
import Card from '../../molecules/Card';
import Form from '../../molecules/Form';
import MultipleSearch from '../../molecules/MultipleSearch';

export default function PropertyFilter() {
  const {
    handleAutoComplete,
    filters,
    emptyFilters,
    autocomplete,
    propertySearchValues,
    handleFilters,
    handleSearchMultipleInput,
    handlePropertyName,
    handleSearchFilter,
    handleClearFilters,
    handleClearAutoComplete,
    query } = useProperty();

  return (
    <div className="search-filter">
      <MultipleSearch
        page='properties'
        search={handleSearchMultipleInput}
        inputValue={propertySearchValues}
        fetch={handleAutoComplete}
        autocomplete={autocomplete}
        handleInput={handlePropertyName}
        clearOptions={handleClearAutoComplete}
        freeSolo
      />
      <Card styles={{marginTop: '16px', marginBottom: '24px'}}>
        <Text fontFamily="ff1" fontWeight='600' fontSize='1.125rem'>Filter by Characteristics</Text>
        <hr />
        <Form filters={filters} page='properties' values={query.filter} handleInput={handleFilters} />
        <div className='filters-actions'>
          <Button type='text' handleClick={() => handleClearFilters()}>Reset</Button>
          <Button handleClick={() => handleSearchFilter()} disabled={emptyFilters}>See Results</Button>
        </div>
      </Card>
    </div>
  )
}
